/* eslint-disable @typescript-eslint/ban-types */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type ThirtyDayDataObject } from '../services/thirtyDayService'

export interface ThirtyDay {
  timestamp: string
  kpi_value: number
}

export interface thirtyDayState {
  isLoading: boolean
  loadingError: string | null
  thirtyDayData: ThirtyDayDataObject | null
  httpStatus: number | null
  calculatedAt: string | null
}

// Initial state of the slice
const initialState: thirtyDayState = {
  isLoading: true,
  loadingError: null,
  thirtyDayData: null,
  httpStatus: null,
  calculatedAt: null
}

// Slice to return from action
export const thirtyDaySlice = createSlice({
  name: 'thirtyDayMap',
  initialState,
  reducers: {
    thirtyDayLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        isLoading: true,
        loadingError: null,
        thirtyDayData: null,
        httpStatus: 0,
        calculatedAt: null
      }
    },
    thirtyDayUpdateAction: (state, action: PayloadAction<{ data: ThirtyDayDataObject, httpStatus: number, CalculatedAt: string }>) => {
      return {
        isLoading: false,
        loadingError: null,
        thirtyDayData: action.payload.data,
        httpStatus: action.payload.httpStatus,
        calculatedAt: action.payload.CalculatedAt
      }
    },
    thirtyDayErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        thirtyDayData: null,
        httpStatus: action.payload.httpStatus,
        calculatedAt: null
      }
    }
  }
})

// Actions to export
export const {
  thirtyDayLoadingAction,
  thirtyDayUpdateAction,
  thirtyDayErrorAction
} = thirtyDaySlice.actions

export default thirtyDaySlice.reducer
